<template>
<svg data-svg-lvl-2="flyleaffront-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430">
<PreviewLayersFlyleaffrontBlockShadowR :params="params" v-if="!params.isFlap7" />
<PreviewLayersFlyleaffrontBlockShadowR_F7 :params="params" v-if="params.isFlap7" />
<PreviewLayersFlyleaffrontBlockFlyleaffrontR :params="params" v-if="!params.isFlap7" />
<PreviewLayersFlyleaffrontBlockFlyleaffrontR_F7 :params="params" v-if="params.isFlap7" />
<PreviewLayersFlyleaffrontBlockContourR :params="params" v-if="!params.isFlap7" />
<PreviewLayersFlyleaffrontBlockContourR_F7 :params="params" v-if="params.isFlap7" />
<component :params="params" :is="`PreviewLayersFlyleaffrontBlockPlasticP${params.plastic.flyleaffrontBlockComponent}`" v-if="params.plastic.flyleaffrontBlockComponent" />
<PreviewLayersFlyleaffrontBlockPocketR :params="params" v-if="params.flyleaffrontPocket" />
<PreviewDraggableInner :params="params" />
</svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default { components: {
      PreviewDraggableInner: () => import('/src/components/preview/DraggableInner'),
     },props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>